"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Submitted = function Submitted() {
  return _react2.default.createElement(
    "g",
    { id: "submitted" },
    _react2.default.createElement("path", {
      d: "M378.31,136.32 L348,106 L211.65,242.35 L242,272.67 L378.31,136.32 Z M469.5,106 L242,333.53 L152.08,243.9 L121.76,274.22 L242,394.39 L500,136.32 L469.5,106 Z M0,274.17 L120.25,394.39 L150.57,364.07 L30.57,243.9 L0,274.17 Z",
      id: "Shape"
    })
  );
};

exports.default = Submitted;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Submitted.js
// module id = 2991
// module chunks = 4